import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { Link } from "gatsby"
import Img from "gatsby-image"

import media from "../../styles/media"
import { FadeInTransition } from "./FadeInTransition"
import { singularize } from "../../utils/common/transforms"

const fadeInDuration = 800

const HeroWrapper = styled.div`
  height: 100vh;
  max-width: 100vw;
  background-color: ${props => props.theme.black};
`

const HeroImage = styled(Img)`
  align-items: center;
  background-size: cover;
  display: flex;
  justify-content: center;
  position: relative;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center center;
  transition: opacity ${fadeInDuration}ms ease-in-out;
`

const HeroTitle = styled.div`
  font-family: StanleyBold, serif;
  font-weight: 700;
  font-style: normal;
  color: ${props => (props.dark ? props.theme.black : props.theme.white)};
  left: 20px;
  bottom: 26px;
  position: absolute;
  z-index: 2;
  max-width: 65%;

  ${media.tablet`
    left: 40px;
    bottom:46px;
  `}

  a {
    color: inherit;
    text-decoration: none;
    &:hover {
      color: ${props => props.theme.red};
    }
  }

  h1,
  h2 {
    display: inline;
    font-size: 20px;
    letter-spacing: -0.27px;
    color: inherit;

    ${media.tablet`
      font-size: 45px;
      letter-spacing: -0.61px;
    `}
  }

  h1 {
    font-family: StanleyPoster, serif;
    font-weight: lighter;
    letter-spacing: -0.57px;
  }

  h2 {
    font-family: StanleyRegular, serif;
    font-style: italic;
    font-weight: normal;
  }
`

export const Hero = ({ fluid, title, titleLink, categories, dark = false }) => {
  function getCategorySubtitleLink(category) {
    const isChildCategory =
      category && category.parentCategory && category.parentCategory.length

    let subtitleLink = ""

    if (category) {
      subtitleLink = isChildCategory
        ? `/roster?category=${encodeURIComponent(
            category.parentCategory[0].name
          )}&subcategories=${encodeURIComponent(category.name)}`
        : `/roster?category=${encodeURIComponent(category.name)}`
    }

    return subtitleLink
  }
  return (
    <HeroWrapper>
      <FadeInTransition duration={fadeInDuration}>
        {({ defaultStyle, transitionStyles }) => (
          <HeroImage
            alt={`${title} - ${categories
              .map(category => category.name)
              .join(", ")}`}
            fluid={fluid}
            fadeIn={false}
            style={{ ...defaultStyle, ...transitionStyles }}
          />
        )}
      </FadeInTransition>
      <HeroTitle dark={dark}>
        <div>
          {titleLink ? (
            <Link to={titleLink}>
              <h1>{title} </h1>
            </Link>
          ) : (
            <h1>{title} </h1>
          )}
          {categories &&
            categories.map((category, i) => {
              return (
                <Link to={getCategorySubtitleLink(category)}>
                  <h2>
                    {category.keepPlural
                      ? category.name
                      : singularize(category.name) +
                        (i === categories.length - 1 ? "" : ", ")}{" "}
                  </h2>
                </Link>
              )
            })}
        </div>
      </HeroTitle>
    </HeroWrapper>
  )
}

Hero.propTypes = {
  fluid: PropTypes.object,
  title: PropTypes.string,
  titleLink: PropTypes.string,
  categories: PropTypes.arrayOf(
    PropTypes.shape({ name: PropTypes.string, keepPlural: PropTypes.bool })
  ),
  dark: PropTypes.bool,
}
